(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'otherMajorsListing', {
            bindings: {
                majorsList:  '<'
            },
            templateUrl:  'app/views/partials/content/other-majors-listing.html',
            controller:   OtherMajorsListingController,
            controllerAs: 'vm'
        });


    /**
     * Renders list of all available majors including majors selector.
     *
     * @param {ng.IScope} $scope
     * @param {Utils} Utils
     * @param {Object} TEXTS
     */
    function OtherMajorsListingController(
        $scope,
        Utils,
        TEXTS
    ){

        // Helper members.

        /** @type {angular.IController} */
        var vm = this;


        /** Expose to the Scope. */
        $scope.TEXTS = TEXTS.DEGREE.MAJORS;


        /** *MUST BE* present to allow directive `collapsible` to bind to the Controller's $postLink event. */
        Utils.addGenericPostLinkTrigger( vm );


    }


    OtherMajorsListingController.$inject = [ '$scope', 'Utils', 'TEXTS' ];
})();
